import { Link, Navigate } from "react-router-dom";
import { PortalShell } from "../components/PortalShell";
import { usePortalAuth } from "../PortalAuthContext";
import { dashboardPathFor } from "./RecipientDashboardPage";

// External Intake & Collection v1.0 PR 4 §2.2 — entry page for an
// authenticated portal session. Remediation Tier 2 #9 (Prompt 9-ii):
// once the per-type shells exist (/portal/buyer, /seller, /vendor,
// /broker), the canonical landing is the AccountType-keyed dashboard.
// This route stays mounted at /portal so existing footer links + magic-
// link fallbacks resolve; it just forwards to the right shell.

export function PackagesIndexPage() {
  const auth = usePortalAuth();

  if (!auth.loading && !auth.me) {
    return (
      <PortalShell pageTitle="Sign in">
        <div className="flex flex-col gap-space-3">
          <h1 className="text-h2 font-display text-onyx m-0">No active session</h1>
          <p className="text-small text-gray-mid">
            <Link to="/portal/login" className="underline">Sign in</Link> or use
            a secure link that we've emailed to you. If your link has expired,
            ask the team for a fresh one.
          </p>
        </div>
      </PortalShell>
    );
  }

  if (auth.me) {
    return (
      <Navigate to={dashboardPathFor(auth.me.accountType, auth.me.kind)} replace />
    );
  }

  return (
    <PortalShell pageTitle="My dashboard">
      <p className="text-small text-gray-mid mt-space-3">Loading…</p>
    </PortalShell>
  );
}
